export type TermsAndConditionsKey = 'registration' | 'login' | 'assetDownload';

export type TermsAndConditions = Partial<Record<TermsAndConditionsKey, string>>;
